export default new (class ScopeHelper {
  saveSelectedScopes(user, selectedScopes) {
    const key = this.getKey(user);
    let latestSelectedScopes = this.getSelectedScopes();

    if (!latestSelectedScopes) {
      let newSelectedScopes = {};
      newSelectedScopes[key] = selectedScopes;
      localStorage.setItem(
        "selected_scopes",
        JSON.stringify(newSelectedScopes)
      );
    } else {
      latestSelectedScopes[key] = selectedScopes;
      localStorage.setItem(
        "selected_scopes",
        JSON.stringify(latestSelectedScopes)
      );
    }
  }
  resetForUser(user) {
    const key = this.getKey(user);
    let latestSelectedScopes = this.getSelectedScopes();

    if (!latestSelectedScopes) {
      // do nothing, nothing is saved
    } else {
      if (latestSelectedScopes) {
        delete latestSelectedScopes[key];
        localStorage.setItem(
          "selected_scopes",
          JSON.stringify(latestSelectedScopes)
        );
      }
    }
  }
  getSelectedScopes() {
    const savedScopes = localStorage.getItem("selected_scopes");
    if (savedScopes) {
      const parsed = JSON.parse(savedScopes);
      return parsed;
    }
    return null;
  }
  getUserSelectedScopes(user) {
    const selectedScopes = this.getSelectedScopes();
    if (!selectedScopes) return null;
    return selectedScopes && selectedScopes[this.getKey(user)]
      ? selectedScopes[this.getKey(user)]
      : [];
  }
  getKey(user) {
    // Can be more sophisticated
    if (!user) return "";
    return user.sub;
  }
  getUserAccessibleScopes(authorizedScopes, preselectedScopes) {
    if (!authorizedScopes || authorizedScopes.length == 0) return null;
    if (authorizedScopes.includes("ALL")) return preselectedScopes;
    let noMoreAccessibleScopes = [];
    preselectedScopes.forEach((scope) => {
      if (!this.userHasAccessToScope(authorizedScopes, scope))
        noMoreAccessibleScopes.push(scope);
    });
    // update preselected scopes so no more authorized scopes don't get selected
    if (noMoreAccessibleScopes.length > 0) {
      const authorizedPreselectedScopes = preselectedScopes.filter(
        (element) => !noMoreAccessibleScopes.includes(element)
      );
      if (authorizedPreselectedScopes > 0) return authorizedPreselectedScopes;
      else if (authorizedScopes && authorizedScopes.length == 1)
        return authorizedScopes;
      else return [];
    }
    return preselectedScopes;
  }
  userHasAccessToScope(authorizedScopes, scope) {
    const scopeAndSuperiorLevels = this.getSumOfSuperiorLevels([scope]);
    const accessibleScopes = authorizedScopes.filter((item) =>
      scopeAndSuperiorLevels.includes(item)
    );
    return accessibleScopes && accessibleScopes.length > 0;
  }
  getSumOfSuperiorLevels(inputStrings) {
    if (inputStrings == null || inputStrings.length == 0) return [];
    const uniqueSuperiorLevels = new Set(
      inputStrings
        .flatMap((inputString) =>
          inputString
            .split(".")
            .map((level, index, levels) => levels.slice(0, index + 1).join("."))
        )
        .filter((level) => level !== "ALL")
    );

    return [...uniqueSuperiorLevels];
  }
  GetClientFromHierarchy(hierarchy) {
    const levels = hierarchy.split(".");
    return levels.length >= 2 ? levels[1] : hierarchy;
  }
})();
